import { client } from '@api/client';
import { URL } from '@api/urls';

import { TAsset } from '@interfaces/assets/asset';
import { IAssetChangeLogVersion } from '@interfaces/assets/assetHistory';
import { IGetAssetLogDTO } from '@interfaces/assets/dto/assetsDTO';
import { IItemsResponse } from '@interfaces/common/response';
import { IShortUserInfo } from '@interfaces/user/user';

export const getAssetHistoryProfile = (assetId: string): Promise<IAssetChangeLogVersion> => {
	return client.get(`${URL.assetHistoryProfile}/${assetId}`);
};

export const getAssetLog = ({
	assetId,
	updatedAt,
	organizationUser,
	page,
	pageSize = 50,
	sortDirection,
	sortFieldName,
	searchValue,
}: IGetAssetLogDTO): Promise<IItemsResponse<TAsset>> => {
	// Field createdAt is the creation date of History record, this date is also equal to updatedAt field of Asset
	// entity. That's why use createdAt to display the updated date of Asset.
	return client.get(`/asset/${assetId}/filter`, {
		params: {
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			'createdAt.from': updatedAt?.from,
			'createdAt.to': updatedAt?.to,
			userName: organizationUser,
		},
	});
};

export const getAssetHistoryUserFilter = (assetId: string): Promise<IShortUserInfo[]> => {
	return client.get(`${URL.assetHistoryProfile}/${assetId}/users`);
};
